<template>
    <div class="box">
        <div class="header">
            <div class="what"></div>
            <div class="front">
                <div class="logo_box">
                    <div class="logo">
                        <img class="logo_img" src="../assets/image/bottomlogo.png" alt="">
                        <div class="right">
                            <!-- <img class="logoname" src="../assets/image/logoname.png" alt=""> -->
                            <div class="desc">欣联联盟</div>
                        </div>
                    </div>
                    <div class="hotline_box">
                        <div class="hotline_tit">
                            <!-- <img class="tit_bg" src="../assets/image/shape.png" alt=""> -->
                            <div class="title">信息技术咨询服务</div>
                        </div>
                        <div class="hotline_phone">
                            <!-- <img style="width:29px;height:24px;" src="../assets/image/phone.png" alt=""> -->
                            <div class="phone_tit">
                                服务热线：
                            </div>
                        </div>
                        <div class="phone">
                            029-84381191
                        </div>
                    </div>
                </div>
            </div>
            <div class="tab_box">
                <div v-for="(item,i) in tabs" :key="i" class="tab_list" :class="index==i?'status':''" @click="tabClick(i)">{{item}}</div>
            </div>
        </div>
        <router-view/>
        <div class="footer">
            <div class="footer_top">
                <div class="top_box">
                    <div class="top_logo">
                        <img class="top_img" src="../assets/image/bottomlogo.png" alt="">
                        <div class="top_tit">互联网创意策划专家</div>
                    </div>
                    <div class="contact_box">
                        <!-- <div class="contact_tit">
                            <div style="margin-right:12px;">微信客服</div>
                            <div style="font-size: 14px;color: #78625A;">BOOKING</div>
                        </div> -->
                        <div class="contact_cont">
                            <div class="address">
                                <img style="width:18px;height:23px;margin-right:17px;" src="../assets/image/address.png" alt="">
                                <div>地址：西安市未央区北二环太华北路十字东北角百寰国际28楼</div>
                            </div>
                            <div class="phones">
                                <img style="width:21px;height:22px;margin-right:17px;" src="../assets/image/phones.png" alt="">
                                <div>电话：029-84381191</div>
                            </div>
                             <div class="mail">
                                <img style="width:20px;height:16px;margin-right:17px;" src="../assets/image/Mail.png" alt="">
                                <div>邮箱：xl20121220@163.com</div>
                            </div>
                        </div>
                    </div>
                    <div class="top_code">
                        <div class="code_tit">
                            <div style="margin-right:12px;">微信客服</div>
                            <div style="font-size: 14px;color: #78625A;">昵称</div>
                        </div>
                        <img class="code_img" src="../assets/image/code.png" alt="">
                    </div>
                </div>
            </div>
            <div class="footer_bottom">
                <div style="display: flex;justify-content: center;">
                    <div class="tabs_box">
                        <div v-for="(item,i) in tabs" :key="i" class="tabs_list">{{item}}</div>
                        <!-- <div class="tabs_list">隐私协议</div> -->
                    </div>
                </div>
                <div class="filing"><a href="https://beian.miit.gov.cn">陕ICP备15015808号</a></div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            tabs:[
                '官网首页',
                // 'tab',
                // 'tab',
                // 'tab',
                '关于我们',
                '联系我们',
                '隐私协议',
            ],
            index:0,
        };
    },
    created() {

    },
    mounted() {
        this.getData()
    },
    methods: {
        getData() {
            console.log(this.$route.query.index)
            if(!this.$route.query.index) {
                this.index = 0
            }else {
                this.index = this.$route.query.index-1;
            }
        },
        tabClick(i) {
            this.index = i
            if(i == 0) {
                this.$router.push({path:'/Home',query:{index:i+1}})
            }else if(i == 1) {
                // this.$router.push({path:'/Features',query:{index:i+1}})
                this.$router.push({path:'/Aboutus',query:{index:i+1}})

            }else if(i == 2) {
                // this.$router.push({path:'/Learning',query:{index:i+1}})
                this.$router.push({path:'/Contactus',query:{index:i+1}})

            }else if(i == 3) {
                this.$router.push({path:'/Update',query:{index:i+1}})
            }else if(i == 4) {
                // this.$router.push({path:'/Aboutus',query:{index:i+1}})
            }else if(i == 5) {
                // this.$router.push({path:'/Contactus',query:{index:i+1}})
            }
        },
    }
};
</script>

<style scoped lang="less">
.box {
    width: 100%;
    height: calc(100vh);
    .header {
        width: 100%;
        background-color: #fff;
        z-index: 10;
        .what {
            width: 100%;height: 4px;background: #3899B3;
        }
        .front {
            display: flex;
            justify-content: center;
            .logo_box {
                display: flex;
                justify-content: space-between;
                width: 1200px;
                .logo {
                    padding: 16px 0 12px 0;
                    display: flex;
                    align-items: center;
                    .logo_img {
                        width: 70px;
                        height: 71px;
                    }
                    .right {
                        margin-left: 20px;
                        .logoname {
                            width: 119px;
                            height: 29px;
                            margin-bottom: 15px;
                        }
                        .desc {
                            font-size: 30px;
                            font-family: PingFang SC;
                            font-weight: bold;
                            color: #3899B3;
                        }
                    }
                }
                .hotline_box {
                    .hotline_tit {
                        position: relative;
                        width: 236px;
                        height: 37px;
                        background-color: #3899B3;
                        border-bottom-left-radius:90px;
                        border-bottom-right-radius: 90px;
                        .tit_bg {
                            width: 100%;
                            height: 100%;
                            margin-top: -1px;
                        }
                        .title {
                            position: absolute;
                            top: 50%;
                            left: 50%;
                            transform: translate(-50%,-50%);
                            text-align: center;
                            line-height: 37px;
                            font-size: 14px;
                            color: #333;
                        }
                    }
                    .hotline_phone {
                        display: flex;
                        justify-content: center;
                        margin: 10px 0;
                        .phone_tit {
                            font-size: 16px;
                            color: #2D2D2D;
                            margin-left: 11px;
                        }
                    }
                    .phone {
                        display: flex;
                        justify-content: center;
                        font-size: 26px;
                        color: #575757;
                        background: linear-gradient(0deg, #3899B3 0%, #3899B3 100%);
                        -webkit-background-clip: text;
                        -webkit-text-fill-color: transparent;
                    }
                }
            }

        }
        .tab_box {
            display: flex;
            justify-content: center;
            width: 100%;
            height: 55px;
            background: #FFFFFF;
            box-shadow: 0px -1px 0px 0px rgba(253, 195, 58, 0.3), 0px 1px 0px 0px #3899B3;
            border-bottom: 1px solid #3899B3;
            .tab_list {
                width: 148px;
                height: 55px;
                font-size: 16px;
                text-align: center;
                color: #333333;
                line-height: 55px;
                margin: 0 20px;
                cursor: pointer;
            }
            .status {
                background: #3899B3;
                color: #fff;
            }
        }
    }
    .footer {
        .footer_top {
            display: flex;
            justify-content: center;
            width: 100%;
            height: 310px;
            background: #222;
            .top_box {
                width: 1200px;
                height: 100%;
                display: flex;
                justify-content: space-between;
                align-items: center;
                .top_logo {
                    .top_img {
                        width: 98px;
                        height: 98px;
                        margin-left: 24px;
                        margin-bottom: 23px;
                    }
                    .top_tit {
                        width: 213px;
                        height: 16px;
                        font-size: 16px;
                        color: #FFFFFF;
                    }
                }
                .contact_box {
                    .contact_tit {
                        display: flex;
                        align-items: center;
                        font-size: 18px;
                        color: #FFFFFF;
                    }
                    .contact_cont {
                        margin-top: 40px;
                        .address,.phones,.mail {
                            display: flex;
                            align-items: center;
                            width: 360px;
                            font-size: 14px;
                            font-weight: bold;
                            color: #FFFFFF;
                            opacity: 0.7;
                            border-bottom: 1px solid #FFFFFF;
                            padding: 0 0 14px 10px;
                            margin-bottom: 20px;
                        }
                    }
                }
                .top_code {
                    .code_tit {
                        display: flex;
                        align-items: center;
                        font-size: 18px;
                        color: #FFFFFF;
                    }
                    .code_img {
                        width: 130px;
                        height: 130px;
                        margin-top: 37px;
                    }
                }
            }
        }
        .footer_bottom {
            width: 100%;
            background: #3899B3;
            .tabs_box {
                display: flex;
                width: 1200px;
                height: 50px;
                .tabs_list {
                    width: 108px;
                    height: 50px;
                    font-size: 13px;
                    text-align: center;
                    color: #333333;
                    line-height: 50px;
                    cursor: pointer;
                }
            }
            .filing {
                width: 100%;
                height: 50px;
                display: flex;
                justify-content: center;
                align-items: center;
                font-size: 13px;
                color: #333333;
                border-top: 1px solid #333333;
            }
        }
    }
}
</style>



// WEBPACK FOOTER //
// src/components/public.vue